var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mz-banner', _vm.zone],on:{"click":function($event){return _vm.trackClick()}}},[_vm._t("default"),(_vm.visible)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }